import React, {FC} from 'react';

import {pluralise} from '@optimaxdev/utils';

import classNames from 'classnames';

import {useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';

import {CartSummaryDiscountConnected} from '../cartSummaryDiscount/cartSummaryDiscount';
import {ShippingPriceConnected} from '../shippingPrice/shippingPrice';

import s from './cartSummaryList.scss';

export type PropsType = {
    activeItemsCount: number;
    shippingProtection: number;
    subtotal: number;
    copay: number;
};

/**
 * Render jsx to html
 * @returns {CartSummaryList} component
 */
export const CartSummaryList: FC<PropsType> = ({
    activeItemsCount,
    copay,
    shippingProtection,
    subtotal,
}) => {
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');

    const renderShippingTotals = () => {
        const showShippingProtection = shippingProtection > 0;
        return (
            <>
                <li className={s.listItem} data-test-name="cartSummaryShipping">
                    <ShippingPriceConnected />
                </li>
                {showShippingProtection && (
                    <li className={s.listItem}>
                        <span>Shipping Protection</span>
                        <span>
                            <Price>{shippingProtection}</Price>
                        </span>
                    </li>
                )}
            </>
        );
    };

    return (
        <ul className={s.list}>
            <li
                className={classNames(s.listItem, {[s.subTitleWithDiscountColor]: isDiscountColor})}
                data-test-name="cartSummarySubtotal"
            >
                <span>
                    Subtotal ({activeItemsCount} {pluralise('item', activeItemsCount)})
                </span>
                <span id="summary_subtotal">
                    <Price>{subtotal}</Price>
                </span>
            </li>
            <li className={s.listItem} data-test-name="cartSummaryCoupons">
                <CartSummaryDiscountConnected />
            </li>
            {copay > 0 && (
                <li className={s.listItem}>
                    <span>Member Co-pay</span>
                    <span>
                        <Price>{copay}</Price>
                    </span>
                </li>
            )}
            {renderShippingTotals()}
        </ul>
    );
};
